var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.editing_question && !_vm.editing_answer
        ? _c(
            "q-modal",
            {
              ref: "modalbody",
              attrs: {
                "content-css": {
                  minWidth: _vm.getMinWidth,
                  maxWidth: _vm.getMaxWidth,
                  minHeight: "90vh"
                }
              },
              on: {
                hide: function($event) {
                  return _vm.hideModal()
                }
              },
              model: {
                value: _vm.show_modal,
                callback: function($$v) {
                  _vm.show_modal = $$v
                },
                expression: "show_modal"
              }
            },
            [
              _c(
                "q-modal-layout",
                [
                  _c(
                    "q-toolbar",
                    { attrs: { slot: "header" }, slot: "header" },
                    [
                      _c("q-btn", {
                        directives: [
                          { name: "close-overlay", rawName: "v-close-overlay" }
                        ],
                        attrs: { flat: "", round: "", dense: "", icon: "close" }
                      }),
                      _c("q-toolbar-title", [
                        _vm._v(_vm._s(_vm.$t("topic") + ": " + _vm.topic.title))
                      ])
                    ],
                    1
                  ),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c(
                          "q-list",
                          [
                            _c(
                              "q-item",
                              { attrs: { dense: "", multiline: "" } },
                              [
                                _vm.topic.avatar
                                  ? _c("q-item-side", {
                                      staticClass: "q-pa-xs",
                                      attrs: { avatar: _vm.topic.avatar }
                                    })
                                  : _c("q-item-side", {
                                      staticClass: "q-pa-xs",
                                      attrs: {
                                        avatar: _vm.getPlaceholderAvatar
                                      }
                                    }),
                                _c(
                                  "q-item-main",
                                  [
                                    _c(
                                      "q-item-tile",
                                      { attrs: { sublabel: "", lines: "2" } },
                                      [
                                        _vm.$q.platform.is.desktop
                                          ? _c(
                                              "span",
                                              { staticClass: "text-light" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("added_by") + " "
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "text-italic text-bold"
                                          },
                                          [_vm._v(_vm._s(_vm.topic.author))]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "q-item-side",
                                  { attrs: { right: "" } },
                                  [
                                    _c(
                                      "q-item-tile",
                                      { attrs: { stamp: "" } },
                                      [
                                        _vm.$q.platform.is.desktop
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("created_in") + ": "
                                                )
                                              )
                                            ])
                                          : _vm._e(),
                                        _c("span", [
                                          _vm._v(_vm._s(_vm.topic.updated_date))
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "q-item-tile",
                                      [
                                        _c(
                                          "q-btn",
                                          {
                                            staticClass: "q-pa-sm",
                                            attrs: {
                                              flat: "",
                                              rounded: "",
                                              color: "negative",
                                              icon: "far fa-flag"
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.report_question = true
                                              }
                                            }
                                          },
                                          [
                                            _c("q-tooltip", [
                                              _vm._v(_vm._s(_vm.$t("report")))
                                            ])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "q-item",
                              { attrs: { dense: "", multiline: "" } },
                              [
                                _c(
                                  "q-item-main",
                                  [
                                    _c(
                                      "q-item-tile",
                                      {
                                        staticClass: "text-center text-bold",
                                        attrs: { label: "", lines: "1" }
                                      },
                                      [_vm._v(_vm._s(_vm.topic.title))]
                                    ),
                                    _vm.markdown_enabled
                                      ? _c("viewer", {
                                          staticClass: "reply q-pt-xs",
                                          attrs: { text: _vm.renderQuestion }
                                        })
                                      : _vm._e(),
                                    !_vm.markdown_enabled
                                      ? _c(
                                          "p",
                                          { staticClass: "reply q-pt-xs" },
                                          [_vm._v(_vm._s(_vm.renderQuestion))]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "q-item",
                              { attrs: { dense: "" } },
                              [
                                _c("q-item-main"),
                                _c(
                                  "q-item-side",
                                  { attrs: { right: "" } },
                                  [
                                    _c(
                                      "q-item-tile",
                                      {
                                        staticClass: "q-mt-sm q-mb-xs q-mx-md"
                                      },
                                      [
                                        _vm.id === _vm.topic.author_id &&
                                        _vm.answers.length < 1
                                          ? _c(
                                              "q-btn",
                                              {
                                                attrs: {
                                                  flat: "",
                                                  rounded: "",
                                                  color: "negative",
                                                  icon: "far fa-trash-alt"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    _vm.delete_question = true
                                                  }
                                                }
                                              },
                                              [
                                                _c("q-tooltip", [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("delete"))
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm.id === _vm.topic.author_id &&
                                        _vm.answers.length < 1
                                          ? _c(
                                              "q-btn",
                                              {
                                                attrs: {
                                                  flat: "",
                                                  rounded: "",
                                                  color: "primary",
                                                  icon: "fas fa-pencil-alt"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.editQuestion(
                                                      _vm.topic
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("q-tooltip", [
                                                  _vm._v(_vm._s(_vm.$t("edit")))
                                                ])
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _c(
                                          "q-btn",
                                          {
                                            attrs: {
                                              disabled:
                                                _vm.id === _vm.topic.author_id,
                                              flat: "",
                                              rounded: "",
                                              color: "primary",
                                              icon: _vm.getLikedIcon(_vm.topic)
                                            },
                                            on: { click: _vm.likeTopic }
                                          },
                                          [
                                            _c("q-tooltip", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getLikedText(_vm.topic)
                                                )
                                              )
                                            ])
                                          ],
                                          1
                                        ),
                                        _vm.topic.likes && _vm.topic.likes > 0
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "q-mt-sm q-mb-xs q-mx-xs"
                                              },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(_vm.topic.likes)
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "q-btn",
                                          {
                                            attrs: {
                                              flat: "",
                                              rounded: "",
                                              color: "primary",
                                              icon: "fas fa-reply"
                                            },
                                            on: { click: _vm.ScrollToAnswerBox }
                                          },
                                          [
                                            _c("q-tooltip", [
                                              _vm._v(_vm._s(_vm.$t("reply")))
                                            ])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _vm.answers && _vm.answers.length > 0
                      ? _c(
                          "div",
                          { ref: "answersBody", staticClass: "col-12" },
                          _vm._l(_vm.answers, function(answer, index) {
                            return _c(
                              "q-list",
                              { key: index, staticClass: "text-align-center" },
                              [
                                _c(
                                  "q-item",
                                  { attrs: { dense: "", multiline: "" } },
                                  [
                                    answer.avatar
                                      ? _c("q-item-side", {
                                          staticClass: "q-pa-xs",
                                          attrs: { avatar: answer.avatar }
                                        })
                                      : _c("q-item-side", {
                                          staticClass: "q-pa-xs",
                                          attrs: {
                                            avatar: _vm.getPlaceholderAvatar
                                          }
                                        }),
                                    _c(
                                      "q-item-main",
                                      [
                                        _c(
                                          "q-item-tile",
                                          {
                                            attrs: { sublabel: "", lines: "2" }
                                          },
                                          [
                                            _vm.$q.platform.is.desktop
                                              ? _c(
                                                  "span",
                                                  { staticClass: "text-light" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("replied_by") +
                                                          " "
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-italic text-bold"
                                              },
                                              [_vm._v(_vm._s(answer.author))]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "q-item-side",
                                      { attrs: { right: "" } },
                                      [
                                        _c(
                                          "q-item-tile",
                                          { attrs: { stamp: "" } },
                                          [
                                            _vm.$q.platform.is.desktop
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("replied_in") +
                                                        ": "
                                                    )
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(answer.updated_date) +
                                                "\n                            "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "q-item-tile",
                                          [
                                            _c(
                                              "q-btn",
                                              {
                                                staticClass: "q-pa-sm",
                                                attrs: {
                                                  flat: "",
                                                  rounded: "",
                                                  color: "negative",
                                                  icon: "far fa-flag alt"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.getReportAnswerFunction(
                                                      answer
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("q-tooltip", [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("report"))
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "q-item",
                                  { attrs: { dense: "" } },
                                  [
                                    _c(
                                      "q-item-main",
                                      [
                                        _c("viewer", {
                                          staticClass: "reply q-pt-xs",
                                          attrs: { text: answer.answer }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "q-item",
                                  { attrs: { dense: "" } },
                                  [
                                    _c("q-item-main"),
                                    _c(
                                      "q-item-side",
                                      { attrs: { right: "" } },
                                      [
                                        _c(
                                          "q-item-tile",
                                          {
                                            staticClass:
                                              "q-mt-sm q-mb-xs q-mx-md"
                                          },
                                          [
                                            _vm.id === answer.author_id
                                              ? _c(
                                                  "q-btn",
                                                  {
                                                    attrs: {
                                                      flat: "",
                                                      rounded: "",
                                                      color: "negative",
                                                      icon: "far fa-trash-alt"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.setAnswerToDelete(
                                                          answer
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("q-tooltip", [
                                                      _vm._v(
                                                        _vm._s(_vm.$t("delete"))
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm.id === answer.author_id
                                              ? _c(
                                                  "q-btn",
                                                  {
                                                    attrs: {
                                                      flat: "",
                                                      rounded: "",
                                                      color: "primary",
                                                      icon: "fas fa-pencil-alt"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.editAnswer(
                                                          answer
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("q-tooltip", [
                                                      _vm._v(
                                                        _vm._s(_vm.$t("edit"))
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _c(
                                              "q-btn",
                                              {
                                                attrs: {
                                                  disabled:
                                                    _vm.id === answer.author_id,
                                                  flat: "",
                                                  rounded: "",
                                                  color: "primary",
                                                  icon: _vm.getLikedIcon(answer)
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.likeAnswer(
                                                      answer
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("q-tooltip", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getLikedText(answer)
                                                    )
                                                  )
                                                ])
                                              ],
                                              1
                                            ),
                                            answer.likes && answer.likes > 0
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "q-mt-sm q-mb-xs q-mx-xs"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " + _vm._s(answer.likes)
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          }),
                          1
                        )
                      : _vm._e()
                  ]),
                  _c("div", { staticClass: "row" }, [
                    !_vm.answers.length && _vm.topic && _vm.topic.status === 1
                      ? _c(
                          "div",
                          { staticClass: "col-12" },
                          [
                            _c(
                              "q-list",
                              {
                                staticClass: "text-align-center",
                                attrs: { "inset-separator": "" }
                              },
                              [
                                _c("q-item-main", [
                                  _c(
                                    "p",
                                    { staticClass: "text-center q-pa-md" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("topic_without_replies"))
                                      )
                                    ]
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]),
                  _vm.topic && _vm.topic.status === 1
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-12" },
                          [
                            _c("editor", {
                              attrs: {
                                initialText: _vm.editor_initial_text,
                                editorText: _vm.message,
                                imagePath: _vm.image_path,
                                imageUpload: _vm.image_upload,
                                custom_directory: _vm.custom_directory,
                                id: _vm.new_uid
                              },
                              on: {
                                setMessageWithImage: _vm.setMessageWithImage,
                                setMessage: _vm.setMessage
                              }
                            })
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm.topic && _vm.topic.status === 4
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "q-my-md text-center col-12" },
                          [
                            _c("h5", { staticClass: "text-h5" }, [
                              _vm._v(_vm._s(_vm.$t("topic_is_closed")))
                            ])
                          ]
                        )
                      ])
                    : _vm._e(),
                  _c(
                    "q-toolbar",
                    { attrs: { slot: "footer" }, slot: "footer" },
                    [
                      _c("q-btn", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.topic && _vm.topic.status === 1,
                            expression: "topic && topic.status === 1"
                          }
                        ],
                        staticClass: "q-mx-sm",
                        attrs: {
                          color: "positive",
                          disabled: _vm.message && _vm.message.length < 3,
                          label: _vm.$t("send_reply")
                        },
                        on: { click: _vm.replyToTopic }
                      }),
                      _c("q-btn", {
                        staticClass: "q-mx-sm",
                        attrs: { color: "negative", label: _vm.$t("close") },
                        on: {
                          click: function($event) {
                            return _vm.hideModal()
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.editing_question
        ? _c(
            "q-modal",
            {
              attrs: {
                "content-css": {
                  minWidth: _vm.getMinWidth,
                  maxWidth: _vm.getMaxWidth,
                  minHeight: "90vh"
                }
              },
              on: {
                hide: function($event) {
                  return _vm.hideModal()
                }
              },
              model: {
                value: _vm.show_modal,
                callback: function($$v) {
                  _vm.show_modal = $$v
                },
                expression: "show_modal"
              }
            },
            [
              _c(
                "q-modal-layout",
                [
                  _c(
                    "q-toolbar",
                    { attrs: { slot: "header" }, slot: "header" },
                    [
                      _c("q-btn", {
                        directives: [
                          { name: "close-overlay", rawName: "v-close-overlay" }
                        ],
                        attrs: { flat: "", round: "", dense: "", icon: "close" }
                      }),
                      _c("q-toolbar-title", [
                        _vm._v(_vm._s(_vm.$t("edit_topic").toUpperCase()))
                      ])
                    ],
                    1
                  ),
                  _c("div", { staticClass: "row q-ma-md" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("p", { staticClass: "q-my-md text-center" }, [
                          _vm._v(_vm._s(_vm.$t("edit_topic")))
                        ]),
                        _c("q-input", {
                          staticClass: "q-my-md",
                          attrs: {
                            "float-label": _vm.$t("topic"),
                            error: _vm.$v.new_title.$error
                          },
                          on: { input: _vm.$v.new_title.$touch },
                          model: {
                            value: _vm.new_title,
                            callback: function($$v) {
                              _vm.new_title = $$v
                            },
                            expression: "new_title"
                          }
                        }),
                        _c("p", { staticClass: "q-my-md text-center" }, [
                          _vm._v(_vm._s(_vm.$t("your_question")))
                        ]),
                        _c("editor", {
                          staticClass: "q-my-md",
                          attrs: {
                            editorText: _vm.message,
                            initialText: _vm.question,
                            imagePath: _vm.image_path,
                            imageUpload: _vm.image_upload,
                            custom_directory: _vm.custom_directory,
                            id: _vm.new_uid
                          },
                          on: {
                            setMessage: _vm.setMessage,
                            setMessageWithImage: _vm.setMessageWithImage
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c(
                    "q-toolbar",
                    { attrs: { slot: "footer" }, slot: "footer" },
                    [
                      _c("q-btn", {
                        staticClass: "q-mx-sm",
                        attrs: {
                          color: "positive",
                          label: _vm.$t("edit_topic"),
                          disabled:
                            _vm.new_title.length < 4 || _vm.message.length < 4
                        },
                        on: { click: _vm.saveEditedQuestion }
                      }),
                      _c("q-btn", {
                        staticClass: "q-mx-sm",
                        attrs: { color: "negative", label: _vm.$t("cancel") },
                        on: {
                          click: function($event) {
                            _vm.editing_question = false
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.editing_answer
        ? _c(
            "q-modal",
            {
              attrs: {
                "content-css": {
                  minWidth: _vm.getMinWidth,
                  maxWidth: _vm.getMaxWidth,
                  minHeight: "90vh"
                }
              },
              on: {
                hide: function($event) {
                  return _vm.hideModal()
                }
              },
              model: {
                value: _vm.show_modal,
                callback: function($$v) {
                  _vm.show_modal = $$v
                },
                expression: "show_modal"
              }
            },
            [
              _c(
                "q-modal-layout",
                [
                  _c(
                    "q-toolbar",
                    { attrs: { slot: "header" }, slot: "header" },
                    [
                      _c("q-btn", {
                        directives: [
                          { name: "close-overlay", rawName: "v-close-overlay" }
                        ],
                        attrs: { flat: "", round: "", dense: "", icon: "close" }
                      }),
                      _c("q-toolbar-title", [
                        _vm._v(_vm._s(_vm.$t("edit_reply").toUpperCase()))
                      ])
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c(
                        "q-list",
                        [
                          _c(
                            "q-item",
                            { attrs: { multiline: "" } },
                            [
                              _vm.topic.avatar
                                ? _c("q-item-side", {
                                    staticClass: "q-pa-xs",
                                    attrs: { avatar: _vm.topic.avatar }
                                  })
                                : _c("q-item-side", {
                                    staticClass: "q-pa-xs",
                                    attrs: { avatar: _vm.getPlaceholderAvatar }
                                  }),
                              _c(
                                "q-item-main",
                                [
                                  _c(
                                    "q-item-tile",
                                    { attrs: { sublabel: "", lines: "2" } },
                                    [
                                      _vm.$q.platform.is.desktop
                                        ? _c(
                                            "span",
                                            { staticClass: "text-light" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("added_by") + " ")
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "text-italic text-bold"
                                        },
                                        [_vm._v(_vm._s(_vm.topic.author))]
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "q-item-side",
                                { attrs: { right: "" } },
                                [
                                  _c("q-item-tile", { attrs: { stamp: "" } }, [
                                    _vm.$q.platform.is.desktop
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("created_in") + ": ")
                                          )
                                        ])
                                      : _vm._e(),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.topic.updated_date))
                                    ])
                                  ]),
                                  _c(
                                    "q-item-tile",
                                    {
                                      staticClass: "q-pa-md",
                                      attrs: {
                                        icon: "far fa-flag",
                                        color: "negative"
                                      }
                                    },
                                    [
                                      _c("q-tooltip", [
                                        _vm._v(_vm._s(_vm.$t("report")))
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "q-item",
                            { attrs: { multiline: "" } },
                            [
                              _c(
                                "q-item-main",
                                [
                                  _c(
                                    "q-item-tile",
                                    {
                                      staticClass: "text-center text-bold",
                                      attrs: { label: "", lines: "1" }
                                    },
                                    [_vm._v(_vm._s(_vm.topic.title))]
                                  ),
                                  _vm.markdown_enabled
                                    ? _c("viewer", {
                                        staticClass: "reply q-pt-md",
                                        attrs: { text: _vm.renderQuestion }
                                      })
                                    : _vm._e(),
                                  !_vm.markdown_enabled
                                    ? _c(
                                        "p",
                                        { staticClass: "reply q-pt-md" },
                                        [_vm._v(_vm._s(_vm.renderQuestion))]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("div", { staticClass: "row q-ma-md" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("p", { staticClass: "q-my-md text-center" }, [
                          _vm._v(_vm._s(_vm.$t("edit_reply")))
                        ]),
                        _c("editor", {
                          staticClass: "q-my-md",
                          attrs: {
                            editorText: _vm.message,
                            initialText: _vm.previous_answer,
                            imagePath: _vm.image_path,
                            imageUpload: _vm.image_upload,
                            custom_directory: _vm.custom_directory,
                            id: _vm.new_uid
                          },
                          on: {
                            setMessage: _vm.setMessage,
                            setMessageWithImage: _vm.setMessageWithImage
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c(
                    "q-toolbar",
                    { attrs: { slot: "footer" }, slot: "footer" },
                    [
                      _c("q-btn", {
                        staticClass: "q-mx-sm",
                        attrs: {
                          color: "positive",
                          label: _vm.$t("edit_reply"),
                          disabled: _vm.message.length < 4
                        },
                        on: { click: _vm.saveEditedAnswer }
                      }),
                      _c("q-btn", {
                        staticClass: "q-mx-sm",
                        attrs: { color: "negative", label: _vm.$t("cancel") },
                        on: {
                          click: function($event) {
                            _vm.editing_answer = false
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "q-dialog",
        {
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "primary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.delete_question = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("delete") },
                    on: {
                      click: function($event) {
                        return _vm.deleteQuestion()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.delete_question,
            callback: function($$v) {
              _vm.delete_question = $$v
            },
            expression: "delete_question"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("delete_topic")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("confirm_delete_topic")))
          ])
        ]
      ),
      _c(
        "q-dialog",
        {
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "primary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.delete_answer = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("delete") },
                    on: {
                      click: function($event) {
                        return _vm.deleteAnswer()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.delete_answer,
            callback: function($$v) {
              _vm.delete_answer = $$v
            },
            expression: "delete_answer"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("delete_reply")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("confirm_delete_reply")))
          ])
        ]
      ),
      _c(
        "q-dialog",
        {
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "primary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.report_question = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("report") },
                    on: { click: _vm.reportQuestion }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.report_question,
            callback: function($$v) {
              _vm.report_question = $$v
            },
            expression: "report_question"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("report_topic")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("confirm_report_topic")))
          ])
        ]
      ),
      _c(
        "q-dialog",
        {
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "primary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.report_answer = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("report") },
                    on: { click: _vm.reportAnswer }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.report_answer,
            callback: function($$v) {
              _vm.report_answer = $$v
            },
            expression: "report_answer"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("report_answer")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("confirm_report_answer")))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }